import React, { createContext, useContext, useState, useCallback } from 'react';

interface TourContextValue {
  activeTourId: string | null;
  startTour: (tourId: string) => void;
  endTour: () => void;
}

const TourContext = createContext<TourContextValue>({
  activeTourId: null,
  startTour: () => {},
  endTour: () => {},
});

export function TourProvider({ children }: { children: React.ReactNode }) {
  const [activeTourId, setActiveTourId] = useState<string | null>(null);

  const startTour = useCallback((tourId: string) => {
    setActiveTourId(tourId);
  }, []);

  const endTour = useCallback(() => {
    setActiveTourId(null);
  }, []);

  return (
    <TourContext.Provider value={{ activeTourId, startTour, endTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  return useContext(TourContext);
}
